import React from "react";
import Signin from "../components/Signin";

const SignIn = () => {
  return (
    <>
      <Signin />
    </>
  );
};

export default SignIn;
